import { render, staticRenderFns } from "./ItemObral.vue?vue&type=template&id=0b4181d4&scoped=true"
import script from "./ItemObral.vue?vue&type=script&lang=js"
export * from "./ItemObral.vue?vue&type=script&lang=js"
import style0 from "./ItemObral.vue?vue&type=style&index=0&id=0b4181d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4181d4",
  null
  
)

export default component.exports